import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'VideoRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'VideoRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'VideoRecord',
    column_type: 'datetime',
  },
  investment_principal: {
    model_name: 'VideoRecord',
    column_type: 'decimal',
  },
  account: {
    model_name: 'VideoRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  account_id: {
    model_name: 'VideoRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  fund: {
    model_name: 'VideoRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  fund_id: {
    model_name: 'VideoRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  status: {
    model_name: 'VideoRecord',
    column_type: 'enum',
  },
  last_investment_date: {
    model_name: 'VideoRecord',
    column_type: 'date',
  },
  reject_reason: {
    model_name: 'VideoRecord',
    column_type: 'string',
  },
  video: {
    model_name: 'VideoRecord',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
